import { render } from "./SurveyMultipleResponse.vue?vue&type=template&id=182cf94c&scoped=true"
import script from "./SurveyMultipleResponse.vue?vue&type=script&lang=js"
export * from "./SurveyMultipleResponse.vue?vue&type=script&lang=js"

import "./SurveyMultipleResponse.vue?vue&type=style&index=0&id=182cf94c&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182cf94c"]])

export default __exports__